import { useStyles } from '@archipro-design/aria';
import { BusinessSupportBlock } from './BusinessSupportBlock';
import * as S from './BusinessSection.style';
import BaseSection from '../base-section/BaseSection';
import EcommerceHeading from '../ecommerce-heading/EcommerceHeading';
import type { BusinessModuleProps } from '@modules/elemental-page/type';

const BusinessSection = ({
    intro,
    textBlocks,
    anchor,
}: BusinessModuleProps) => {
    const { css } = useStyles();

    return (
        <BaseSection style={S.Container} id={anchor}>
            {intro && (
                <EcommerceHeading
                    style={S.HeadingCustom}
                    title={intro}
                    color={'black'}
                />
            )}
            {textBlocks && textBlocks.length > 0 && (
                <div className={css(S.BlocksContainer)}>
                    {textBlocks.map((block) => {
                        if (!block) {
                            return null;
                        }
                        return (
                            <BusinessSupportBlock key={block.id} {...block} />
                        );
                    })}
                </div>
            )}
        </BaseSection>
    );
};

export default BusinessSection;
